/**
 * Kopfzeile des Tagesrasters (Board „Vertrieb“): Wochentag und Tageszahl, heute auf Wald, das
 * Wochenende auf Papier. „Heute" kommt aus der Objektzeit des Readmodels, nie aus der Browserzeit.
 */
import { cn } from '@/shared/lib/cn';
import { isWeekendIso, parseIso } from './calendarDates';
import { weekdayShort } from './calendarFormat';
import { gridColumns } from './calendarGeometry';

interface DayHeaderRowProps {
  dates: string[];
  today: string;
  sidebarWidth: number;
  dayMin: number;
}

export function DayHeaderRow({ dates, today, sidebarWidth, dayMin }: DayHeaderRowProps) {
  return (
    <div
      className="bg-card border-hairline sticky top-0 z-30 grid border-b"
      style={{ gridTemplateColumns: gridColumns(sidebarWidth, dates.length, dayMin) }}
    >
      <div className="bg-card text-ink-soft sticky left-0 z-40 flex items-center px-[18px] font-mono text-[10px] font-semibold uppercase tracking-[0.14em]">
        Apartment
      </div>
      {dates.map((date) => {
        const isToday = date === today;
        return (
          <div
            key={date}
            className={cn(
              'border-hairline flex h-14 flex-col items-center justify-center gap-0.5 border-l',
              isToday ? 'bg-forest text-white' : isWeekendIso(date) && 'bg-paper',
            )}
          >
            <span className="text-[10px] font-bold uppercase tracking-[0.08em]">
              {weekdayShort(date)}
            </span>
            <span className="font-mono text-sm font-semibold">{parseIso(date).getUTCDate()}</span>
            {isToday && <span className="sr-only">heute</span>}
          </div>
        );
      })}
    </div>
  );
}
